import { PaginationInterface } from "interfaces/pagination.interface";

export enum MetaActionTypes {
  FETCH_META_PAGINATION_REQUEST = "FETCH_META_PAGINATION_REQUEST",
  FETCH_META_PAGINATION_SUCCESS = "FETCH_META_PAGINATION_SUCCESS",
  FETCH_META_PAGINATION_FAILURE = "FETCH_META_PAGINATION_FAILURE",
}

// Action interfaces
export interface FetchMetaPaginationRequestAction {
  type: MetaActionTypes.FETCH_META_PAGINATION_REQUEST;
}

export interface FetchMetaPaginationSuccessAction {
  type: MetaActionTypes.FETCH_META_PAGINATION_SUCCESS;
  payload: PaginationInterface;
}

export interface FetchMetaPaginationFailureAction {
  type: MetaActionTypes.FETCH_META_PAGINATION_FAILURE;
  payload: string;
}

// Action creators
export const fetchMetaPaginationRequest =
  (): FetchMetaPaginationRequestAction => ({
    type: MetaActionTypes.FETCH_META_PAGINATION_REQUEST,
  });

export const fetchMetaPaginationSuccess = (
  data: PaginationInterface
): FetchMetaPaginationSuccessAction => ({
  type: MetaActionTypes.FETCH_META_PAGINATION_SUCCESS,
  payload: data,
});

export const fetchMetaPaginationFailure = (
  error: string
): FetchMetaPaginationFailureAction => ({
  type: MetaActionTypes.FETCH_META_PAGINATION_FAILURE,
  payload: error,
});

export type MetaActions =
  | FetchMetaPaginationRequestAction
  | FetchMetaPaginationSuccessAction
  | FetchMetaPaginationFailureAction;
